module.exports = __webpack_public_path__ + "2e99125cb9f16ba310d422b579f72c56.svg";